import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getProductById } from '../data/products';
import { useFortuneData } from '../contexts/FortuneContext';
import '../styles/ProductDetailPage.css';

const ProductDetailPage = () => {
  const { t } = useTranslation();
  const { productId } = useParams();
  const navigate = useNavigate();
  const { setSelectedProduct } = useFortuneData();
  const [product, setProduct] = useState(null);
  const [activeTab, setActiveTab] = useState('details');

  useEffect(() => {
    const foundProduct = getProductById(productId);
    setProduct(foundProduct);
  }, [productId]);

  const handleBuyNow = () => {
    if (product) {
      setSelectedProduct(product);
      navigate('/birth-input');
    }
  };

  if (!product) {
    return (
      <div className="product-not-found">
        <h2>{t('product_not_found')}</h2>
        <Link to="/" className="back-home-link">
          {t('back_to_home')}
        </Link>
      </div>
    );
  }

  return (
    <div className="product-detail-page">

      <div className="product-content">
        <div className="product-image-container">
          <img src={product.image} alt={t(product.titleKey)} className="product-image" />
          <div className="tag">{t(product.category)}</div>
        </div>

        <div className="product-info">
          <h2 className="product-title">{t(product.titleKey)}</h2>
          <div className="price-container">
            <div className="price-row">
              <span className="price-label">{t('original_price')}</span>
              <span className="original-price">
                {new Intl.NumberFormat().format(product.originalPrice)}
              </span>
            </div>
            <div className="price-row">
              <span className="price-label">{t('discount_rate')}</span>
              <span className="discount-rate">{product.discountRate}%</span>
            </div>
            <div className="price-row final">
              <span className="price-label">{t('final_price')}</span>
              <span className="final-price">
                {new Intl.NumberFormat().format(product.finalPrice)}
              </span>
            </div>
          </div>

          <button className="buy-button" onClick={handleBuyNow}>
            {t('buy_now')}
          </button>
        </div>

        <div className="product-tabs">
          <button 
            className={`tab-button ${activeTab === 'details' ? 'active' : ''}`}
            onClick={() => setActiveTab('details')}
          >
            {t('product_details')}
          </button>
          <button 
            className={`tab-button ${activeTab === 'reviews' ? 'active' : ''}`}
            onClick={() => setActiveTab('reviews')}
          >
            {t('reviews')}
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'details' ? (
            <div className="details-content">
              <p className="product-description">
                {t(product.descriptionKey)}
              </p>
              
              <h3 className="includes-title">{t('product_includes')}</h3>
              <ul className="details-list">
                {product.details.map((detail, index) => (
                  <li key={index}>{t(detail)}</li>
                ))}
              </ul>
            </div>
          ) : (
            <div className="reviews-content">
              {product.reviews.map(review => (
                <div className="review-item" key={review.id}>
                  <div className="review-header">
                    <span className="reviewer-name">{t(review.author)}</span>
                    <div className="rating">
                      {Array(review.rating).fill('★').join('')}
                    </div>
                  </div>
                  <p className="review-comment">{t(review.comment)}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDetailPage;
